export function chance(value?: number) {
    return value && Math.random() <= value;
}

export function clamp(value: number, min: number, max: number) {
    return Math.max(min, Math.min(max, value));
}

export function hypotenuse(a: number, b?: number) {
    return Math.sqrt(a * a + (b !== undefined ? b * b : a * a));
}

export function random(min: number, max: number, rounded = false) {
    const value = (max - min) * Math.random() + min;
    return rounded ? Math.round(value) : value;
}

export function round(value: number, decimals: number) {
    const multiplier = Math.pow(10, decimals);
    return Math.round(value * multiplier) / multiplier;
}